import "./TnsEmpowering.css";

const features = [
  {
    icon: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/empower-icon1.svg",
    title: "Global GDS Access",
    desc: "One connection to the world's travel content — Sabre's GDS unites airline, hotel, and car inventory from traditional, NDC, and low-cost carrier sources in a single platform, so your agencies book from one screen instead of juggling separate systems for each supplier.",
  },
  {
    icon: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/empower-icon2.svg",
    title: "Smarter Agency Operations",
    desc: "From free, jargon-free tools for new consultants to advanced servicing for complex itineraries, Sabre Mosaic gives your agency a technology stack that grows with your team — cutting training time, reducing manual work, and letting consultants focus on travelers instead of screens.",
  },
  {
    icon: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/empower-icon3.svg",
    title: "Accelerating Your NDC Journey",
    desc: "As airlines shift premium content to NDC, TNS keeps your agencies ahead of the curve — unified access to NDC, GDS, and low-cost carrier fares in one workflow, with no extra integration work.",
  },
  {
    icon: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/empower-icon4.svg",
    title: "Localized Support for Training & Customer Service",
    desc: "Every TNS market gets a local team, not a call center on another continent — certified trainers, hands-on onboarding, and helpdesk support from people who understand your regulatory environment, booking patterns, and customers.",
  },
];

function TnsEmpowering() {
  return (
    <section className="tns-empowering-section section-padding">
      <div className="tns-empowering-heading">
        <h2 className="heading-title">
          <span className="title-blue">Empowering Travel </span> Connections
          <br />
          Across Africa
        </h2>

        <p className="desc">
          African travel businesses need technology that works in real markets—
          fast connectivity, accurate bookings, and tools that simplify daily
          operations. TNS Global brings real-world African travel technology
          that helps agencies adopt and use GDS solutions more confidently,
          improve customer service, and manage complex itineraries with ease.
        </p>
      </div>

      <div className="tns-empowering-content">
        <div className="tns-empowering-left">
          {features.map((item, index) => (
            <div className="tns-feature-item" key={index}>
              <div className="tns-feature-icon">
                <img src={item.icon} alt={item.title} />
              </div>

              <div className="tns-feature-content">
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="tns-empowering-right">
          {/* Desktop Image */}
          <img
            src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/TNS/empower-img.png"
            alt=""
            className="img-top empowering-desktop-img"
          />

          {/* Mobile Image */}
          <img
            src="/assets/mobile-home.png"
            alt=""
            className="img-top empowering-mobile-img"
          />
        </div>
      </div>
    </section>
  );
}

export default TnsEmpowering;
